/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useCallback } from 'react';
import {useDropzone} from 'react-dropzone'

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import { isPropsEqual } from '@fullcalendar/react';


function Start(props) {
  const [feedback, setFeedback] = useState("First, do you have the applicant's I-941?")
  const [next, setNext] = useState(false)

  function Upload() {
    const onDrop = useCallback(acceptedFiles => {
      // Do something with the files
      console.log(acceptedFiles, "checking acceptedFiles")
      setFeedback("Got it! Let's confirm some details ...")
      setNext(true)
    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    return (
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <MDButton style={{"margin-top": "35px"}} variant="gradient" color="info" size="large">
          Yes, let me Upload
        </MDButton>
      </div>
    )
  }

  return (
    <MDBox>
      <MDBox width="82%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            {feedback}
          </MDTypography>
          {next ? 
            <MDButton onClick={props.handleNext()}>Next</MDButton>
          :
           <Upload/>
          }
          {/* <Upload/> */}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default Start;
